module.exports = {
      id: "mynews-usage",
      viewBox: "0 0 13.581 13.581",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#mynews",
      toString: function () {
        return this.url;
      }
    }